// export const RECORD_ADDRESS = 'RECORD_ADDRESS'
export const GET_USERADDRESS = 'GET_USERADDRESS'
export const TABSELECT = 'TABSELECT'
export const GET_ONACTIVE = 'GET_ONACTIVE'
export const GET_BUSACTIVE = 'GET_BUSACTIVE'
export const ORDERSN = 'ORDERSN'
export const SEARCHNUM = 'SEARCHNUM'
export const ADDRESS = 'ADDRESS'
export const GET_MYORDERS = 'GET_MYORDERS'
export const ADDRESSLISTNUM = 'ADDRESSLISTNUM'
export const DELIVERY = 'DELIVERY'
export const ORDERINFO = 'ORDERINFO'
export const REASON = 'REASON'
export const BACKTIME = 'BACKTIME'
export const DESCRI = 'DESCRI'
export const REFUNDID = 'REFUNDID'
export const BACKPRICE = 'BACKPRICE'
export const DRAWBACKOBJ = 'DRAWBACKOBJ'
export const ORDERDETAILS = 'ORDERDETAILS'
export const IMGURL = 'IMGURL'
export const SETEDITADDRESS = 'SETEDITADDRESS'
export const OLDADDRESS = 'OLDADDRESS'
export const ISCONFIRM = 'ISCONFIRM'
export const ISNULL = 'ISNULL'
export const GET_DEFAULTADDRESSISNULL = 'GET_DEFAULTADDRESSISNULL'
export const ISSCROLL = 'ISSCROLL'
export const ADDTYPE = 'ADDTYPE'
export const CART = 'CART'
export const SHOP = 'SHOP'
export const PRICE = 'PRICE'
export const THING = 'THING'
export const COMPANYS = 'COMPANYS'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js